import { createSimpleButtonToolbarItem } from './simple-button-toolbar-item.factory';
import { ActionIds } from '../actions/action.types';

/**
 * Reset to Today toolbar item for o2d timeline views.
 *
 * Uses createSimpleButtonToolbarItem() factory.
 * CSS class 'focus-today' replaces the legacy 'week-view' class (rename per PRD-025).
 * Button label is rendered via CSS ::after with `content: attr(data-label)`.
 *
 * On click: executes timeline.jumpToToday action which sets the cursor to
 * DateTime.utc().startOf('day').minus({day: 1}) so "today" appears at the
 * left viewport edge (the timeline renders from the day AFTER the cursor).
 */
export const resetToTodayToolbarItem = createSimpleButtonToolbarItem({
    id: 'reset-to-today',
    cssClass: 'focus-today',
    labelKey: 'toolbar.focusToday',
    actionId: ActionIds.TIMELINE_JUMP_TO_TODAY,
    position: 'start',
    order: 0,
});
